import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TranslationsService } from 'src/app/translations/private/services/translations.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  public go: string;
  public isMmcUser: boolean;
  public path: string = null;

  constructor(
    private authService: AuthService,
    private translationsService: TranslationsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    // Not mmc user by default
    this.isMmcUser = false;
    // Is mmc user?
    this.authService.getUserLogged().subscribe({
      next: user => {
        if (user) {
          this.isMmcUser = user.client.name.toLowerCase() === 'mmc' ? true : false;
        }
      },
    });

    this.go = 'dashboard';

    this.router.events.subscribe(val => {
      // see also
      if (val instanceof NavigationEnd) {
        this.path = val.url;
      }
    });

  }

}
